import { useEffect, useState } from 'react';

import { useLocale } from 'state/intl';
import { getConfigValue } from 'utils/environment';

declare global {
  interface Window {
    UC_UI: any;
  }
}

const USER_CENTRICS_URL = 'https://app.usercentrics.eu/browser-ui/latest/loader.js';

/**
 * Loads Usercentrics banner sdk cookie consent script
 */
export function useExternalSdk() {
  const [loaded, setLoaded] = useState(false);
  const { language } = useLocale();

  useEffect(() => {
    const { scriptId = '' } = getConfigValue('cookieBanners');
    if (!scriptId) {
      return;
    }

    if (window?.UC_UI?.isInitialized()) {
      setLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = USER_CENTRICS_URL;
    script.dataset.settingsId = scriptId;
    script.dataset.language = language;
    script.id = 'usercentrics-cmp';
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [language]);

  return { loaded };
}
